export enum TransactionItemFilterStatuses {
    ALL = 0,
    UNMATCHED = 1,
    MATCHED = 3,
    AUTOMATICALLY_MATCHED = 4,
    EXCLUDED = 6
}
